import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()({
  container: {
    marginLeft: 'auto',
    marginRight: '0 !important',
  },
})
